import { ProductValue } from "./product.value";
import { MutableValue } from "../api/mutable-value.interface";

export default class Product implements MutableValue {
  public isNew = true;

  constructor(readonly id: ProductValue, readonly name: string) {}

  get hasBreed(): boolean {
    return [
      ProductValue.FOREVERS_DOG,
      ProductValue.HUGGABLES_DOG,
      ProductValue.PETSIE_DOG,
    ].includes(this.id);
  }

  get hasName(): boolean {
    return [
      ProductValue.BULK_SAMPLE,
      ProductValue.FOREVERS_CAT,
      ProductValue.FOREVERS_DOG,
      ProductValue.FOREVERS_OTHER,
      ProductValue.HUGGABLES_CAT,
      ProductValue.HUGGABLES_DOG,
      ProductValue.HUGGABLES_OTHER,
      ProductValue.PETSIE_CAT,
      ProductValue.PETSIE_DOG,
      ProductValue.PETSIE_OTHER,
      ProductValue.BUDDY_PILLOW,
      ProductValue.PILLOW,
      ProductValue.PILLOW_BULK_SAMPLE,
      ProductValue.WAGGABLES_DOG,
    ].includes(this.id);
  }

  get isActive(): boolean {
    return [
      ProductValue.BUDSIE,
      ProductValue.SELFIE,
      ProductValue.BULK_SAMPLE,
      ProductValue.SPECIALITY_COMMISSION,
      ProductValue.FOREVERS_CAT,
      ProductValue.FOREVERS_DOG,
      ProductValue.FOREVERS_OTHER,
      ProductValue.PILLOW,
      ProductValue.PILLOW_BULK_SAMPLE,
      ProductValue.PRINTED_SOCKS,
      ProductValue.BUDSIES_PALS,
      ProductValue.BUDDY_PILLOW,
      ProductValue.PHRASE_PILLOW,
    ].includes(this.id);
  }

  public toString = (): string => {
    return this.name;
  };
}
